import AutoModeIcon from '@mui/icons-material/AutoMode';
import ConstructionIcon from '@mui/icons-material/Construction';
import HomeIcon from '@mui/icons-material/Home';

export const SUPPLY_PLANNING_MENU = [
    {
      id: 'home',
      name: 'Home',
      icon: <HomeIcon />,
      path: "/",
      rules: [],
    },
    {
      id: 's4',
      name: 'DQ S4',
      icon: <ConstructionIcon />,
      rules: [
        { name: 'Consolidated Rule Level',path: "ruleLevel" },
        { name: 'Consolidated Material Level',path: "materialLevel" },
      ],
    },
    {
      id: 'ibp',
      name: 'DQ IBP',
      icon: <AutoModeIcon />,
      rules: [
        {
          name: 'Landing Page',
          path: "IBPLandingPage"
        },
      ]
    },
    {
      id: 'kpi',
      name: 'KPI Metrices',
      icon: <AutoModeIcon />,
      rules: [
        { name: 'Parameter Adherence (past trend) – at aggregated level with drill downs (Top 10 SKUs min and max stock violation; Minimum stock violation drill down; Maximum stock violation drill down)' },
        { name: 'Fill Rate Adherence – % of kits on target (based on Service Level assigned due to segmentation strategy)' },
        { name: 'Inventory WO – Associated with sales, OU, not CPS' },
        { name: 'Forecast Accuracy at Kit Level' },
        { name: 'Inventory, forward looking (incident): Total current/projected stock vs. Target max inventory position' },
        { name: 'Safety stock adherence' },
        { name: 'Lot size adherence' },
        { name: 'Lead time adherence * within Materials Planning Workstream Analytics' },
        { name: 'Safety Stock composition per source - % Count of Materials' },
        { name: 'Safety Stock composition per source - % Value of Safety Stock' },
        { name: 'Safety Stock Value difference: IO Recommendation vs Final SS' },
        { name: 'Count of Safety Stock Master Data changes made directly in S4, by date and user' },
        { name: 'IBP IO Process Tracker per Plant -- TO BE REVIEWED ' },
      ]
    }
  ]